import { gql } from "apollo-boost";
import { fragments } from "../queries/FranchisesList";

export default gql`
  mutation createFranchise($input: FranchiseInput!) {
    createFranchise(input: $input) {
      ...FranchiseQueryFranchise
    }
  }
  ${fragments.franchise}
`;



// WEBPACK FOOTER //
// ./src/mutations/CreateFranchise.js